import { Link } from "react-router-dom";
import { useScrollReveal, getRevealClass } from "@/hooks/useScrollReveal";
import { newsList } from "@/mocks/news";

export default function NewsSection() {
  const latest = newsList.slice(0, 2);
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="py-3 md:py-6 px-3 md:px-6 lg:px-8 bg-[#f0efef]">
      <div className="max-w-7xl mx-auto bg-white rounded-[20px] overflow-hidden">
        <div className="p-4 md:p-8 lg:p-10">
          <div ref={ref} className={getRevealClass(isVisible)}>
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 md:mb-14">
              <div>
                <h2 className="text-3xl lg:text-4xl font-bold text-black tracking-tight mb-1 text-center md:text-left">News</h2>
                <p className="text-sm text-gray-400 mb-4 text-center md:text-left">ニュース</p>
                <div className="w-8 h-px bg-black mx-auto md:mx-0" />
              </div>
              <Link
                to="/news"
                className="hidden md:inline-flex items-center gap-2 text-xs tracking-widest font-semibold text-black border-b border-black pb-0.5 hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
              >
                すべて表示 <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {latest.map((item, index) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group cursor-pointer block"
              >
                <div className="aspect-square w-full overflow-hidden rounded-lg mb-4">
                  <img
                    src={item.image}
                    alt={item.title}
                    className={`w-full h-full object-cover ${index === 0 ? "object-bottom" : "object-top"} group-hover:scale-105 transition-transform duration-500`}
                  />
                </div>
                <div className="flex items-center gap-3 mb-2 justify-center md:justify-start">
                  <span className="text-[10px] text-gray-400 tracking-wider whitespace-nowrap">{item.date}</span>
                  <span className="text-[10px] border border-gray-300 text-gray-500 px-2 py-0.5 whitespace-nowrap">{item.category}</span>
                </div>
                <p className="text-sm font-medium text-black line-clamp-2 leading-relaxed text-center md:text-left">{item.title}</p>
              </Link>
            ))}
          </div>

          <div className="mt-6 md:mt-8 flex justify-center">
            <Link
              to="/news"
              className="inline-flex items-center gap-2 text-xs tracking-widest font-semibold text-black border-b border-black pb-0.5 cursor-pointer whitespace-nowrap"
            >
              すべて表示 <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
